import {StyleSheet} from "aphrodite";

import Clickable from "@khanacademy/wonder-blocks-clickable";
import {View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {SchedulePolicy, useTimeout} from "@khanacademy/wonder-blocks-timing";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@khan/shared-styles";
import {cssUrl} from "@khan/urls";
import {scrollToElement} from "@khan/util-scrolling";

import {MarketingColors} from "./constants.ts";

import caretDownIcon from "@phosphor-icons/core/bold/caret-down-bold.svg";

type Props = {
    kind: "ScrollButton";
    copy: string;
    scrollToSelector: string;
    alternateBackground?: boolean;
};
export default function ScrollButton(props: Props) {
    const {copy, scrollToSelector, alternateBackground} = props;

    const {set: startTimeout} = useTimeout(
        () => {
            const el = document.querySelector(scrollToSelector) as HTMLElement;
            if (el) {
                scrollToElement(el, 450, () => {
                    el.tabIndex = -1;
                    el.focus();
                });
            }
        },
        0,
        {
            schedulePolicy: SchedulePolicy.OnDemand,
        },
    );

    return (
        <View style={styles.desktopContainer}>
            <Clickable
                style={[
                    styles.desktopButton,
                    alternateBackground ? styles.desktopBtnAlt : null,
                ]}
                testId="scroll-button"
                title={copy}
                aria-label={copy}
                onClick={() => startTimeout()}
            >
                {() => (
                    <PhosphorIcon
                        icon={caretDownIcon}
                        color={color.white}
                        style={styles.chevron}
                        size="small"
                    />
                )}
            </Clickable>
        </View>
    );
}

// Above this height, it's silly to try to fill a hero on a single page.
// In this case, we should hide the scroll button, and shorten the hero so that
// the next module is visible.
export const hideScrollButtonOnMobileMq =
    "@media screen and (min-height: 750px)";

const styles = StyleSheet.create({
    desktopContainer: {
        height: 0,
        maxHeight: 0,
        overflow: "visible",
        textAlign: "center",
        background: MarketingColors.lightGray,
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        zIndex: 2,
    },
    desktopButton: {
        position: "absolute",
        left: "50%",
        backgroundImage: cssUrl(
            "/images/marketing-content/scroll-more-button.png",
        ),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "contain",
        height: 29,
        width: 30,
        transform: "translateX(-50%)",
        cursor: "pointer",
        margin: "40px 0 0 0",
        [mediaQueries.mdOrLarger]: {
            height: 36,
            width: 38,
        },
        [mediaQueries.lgOrLarger]: {
            height: 40,
            width: 42,
        },
    },
    desktopBtnAlt: {
        backgroundImage: cssUrl(
            "/images/marketing-content/button-background-green.png",
        ),
        margin: "5px 0 0 0",
        height: 68,
        width: 83,
    },
    chevron: {
        verticalAlign: "middle",
    },
});
